module.exports = __webpack_public_path__ + "img/custom_client_seed_2_es.c0eb1e6d.png";